/**
 * Formatação de números para a tela — pura, sem servidor, para o painel e a
 * API falarem igual.
 */
export function moeda(v: number | null): string {
  return v === null ? "—" : v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function duracaoHumana(segundos: number | null): string {
  if (segundos === null) return "—";
  if (segundos < 60) return `${segundos}s`;
  if (segundos < 3600) return `${Math.round(segundos / 60)} min`;
  return `${(segundos / 3600).toFixed(1).replace(".", ",")} h`;
}
